import animator from 'canvas-animator'
// import StackBlur from 'stackblur-canvas'

export default class XiPart extends animator.shapes.Bitmap {
  constructor (context = null, x = 0, y = 0, w = 100, h = 100, img, imgBlurred, imgWidth, imgHeight, targetX, targetY, targetScale, targetRotation, targetBlur, alphaDistance) {
    super(context, x, y, w, h, img)
    this.moveWithMouse = false
    this.initX = x
    this.initY = y
    this.targetX = targetX
    this.targetY = targetY
    this.targetScale = targetScale
    this.targetRotation = targetRotation
    this.targetBlur = targetBlur
    this.alphaDistance = alphaDistance

    this.blurredImage = imgBlurred
    this.blurRate = 0

    const EXPLODE_RATE = 0.7
    const explodeDx = (this.targetX - this.initX) * EXPLODE_RATE
    const explodeDy = (this.targetY - this.initY) * EXPLODE_RATE
    const expandDx = (this.targetX - this.initX) - explodeDx
    const expandDy = (this.targetY - this.initY) - explodeDy
    this
    .addTween({
      duration: XiPart.DELAY_TIME
    })
    .addTween({
      duration: XiPart.EXPLODE_TIME,
      target: {
        scale: this.scale + (this.targetScale - this.scale) * EXPLODE_RATE,
        rotation: this.rotation + (this.targetRotation - this.rotation) * EXPLODE_RATE,
        blurRate: this.blurRate + (this.targetBlur - this.blurRate) * EXPLODE_RATE
      },
      update: (progress, easedProgress) => {
        this.alpha = 1 - Math.sqrt(this.x * this.x + this.y * this.y) / this.alphaDistance
        this.x = this.initX + explodeDx * easedProgress - XiPart.mousePosition.x * XiPart.MOUSE_MOVE_RATE * this.scale * easedProgress
        this.y = this.initY + explodeDy * easedProgress - XiPart.mousePosition.y * XiPart.MOUSE_MOVE_RATE * this.scale * easedProgress
      },
      ease: 'sineOut'
    })
    .addTween({
      duration: XiPart.GAP_TIME,
      update: (progress, easedProgress) => {
        this.x = this.initX + explodeDx - XiPart.mousePosition.x * XiPart.MOUSE_MOVE_RATE * this.scale
        this.y = this.initY + explodeDy - XiPart.mousePosition.y * XiPart.MOUSE_MOVE_RATE * this.scale
      }
    })
    .addTween({
      duration: XiPart.EXPAND_TIME,
      target: {
        scale: this.targetScale,
        rotation: this.targetRotation,
        blurRate: this.targetBlur
      },
      update: (progress, easedProgress) => {
        this.alpha = 1 - Math.sqrt(this.x * this.x + this.y * this.y) / this.alphaDistance
        this.x = this.initX + explodeDx + expandDx * easedProgress - XiPart.mousePosition.x * XiPart.MOUSE_MOVE_RATE * this.scale
        this.y = this.initY + explodeDy + expandDy * easedProgress - XiPart.mousePosition.y * XiPart.MOUSE_MOVE_RATE * this.scale
      },
      ease: 'elasticOut'
    })
    .addTween({
      duration: Number.POSITIVE_INFINITY,
      update: () => {
        this.x = this.targetX - XiPart.mousePosition.x * XiPart.MOUSE_MOVE_RATE * this.scale
        this.y = this.targetY - XiPart.mousePosition.y * XiPart.MOUSE_MOVE_RATE * this.scale
      }
    })

    // create temp canvas for blur
    /*
    this.imgWidth = imgWidth
    this.imgHeight = imgHeight
    this.originalImage = this.image

    this.tempCanvas = document.createElement('canvas')
    this.tempCanvas.width = imgWidth * 3
    this.tempCanvas.height = imgHeight * 3
    this.tempCanvas.getContext('2d').drawImage(this.originalImage, this.imgWidth, this.imgHeight, this.imgWidth, this.imgHeight)

    this.width = this.width * 3
    this.height = this.height * 3
    this.image = this.tempCanvas
    */
  }

  _draw () {
    this.context.globalAlpha = this.alpha * (1 - this.blurRate)
    this.context.drawImage(this.image, -this.width / 2, -this.height / 2, this.width, this.height)
    this.context.globalAlpha = this.alpha * this.blurRate
    this.context.drawImage(this.blurredImage, -this.width / 2, -this.height / 2, this.width, this.height)
  }
}
XiPart.mousePosition = {
  x: 0,
  y: 0
}
XiPart.DELAY_TIME = 0.8
XiPart.EXPLODE_TIME = 0.6
XiPart.GAP_TIME = 0
XiPart.EXPAND_TIME = 3
XiPart.MOUSE_MOVE_RATE = 0.07
